module.exports = __webpack_public_path__ + "img/share_poster_3.83d85eb4.svg";